import API from '@/api'
import { createUserCarObject, createUserObject, getRawUserCarId, getRawUserId } from '@/utils/validation/user'
import { isNotStarted } from '@/utils/validation/car'

export const moduleName = 'userManager'

export const actionTypes = {
  ACTION_INIT_WS: 'ACTION_INIT_WS',
  ACTION_LOAD_USERS: 'ACTION_LOAD_USERS',
  ACTION_EDIT_USER: 'ACTION_EDIT_USER',
  ACTION_DELETE_USER: 'ACTION_DELETE_USER',
  ACTION_JOIN_TO_USER_MANAGER: 'ACTION_JOIN_TO_USER_MANAGER'
}

export const getterTypes = {
  GETTER_CHECKED_ROWS: 'GETTER_CHECKED_ROWS',
  GETTER_USERS: 'GETTER_USERS',
  GETTER_USERS_COUNT: 'GETTER_USERS_COUNT'
}

export const mutationTypes = {
  SET_CHECKED_ROW: 'SET_CHECKED_ROW',
  SET_CHECKED_ROWS: 'SET_CHECKED_ROWS',
  UNSET_CHECKED_ROWS: 'UNSET_CHECKED_ROWS',
  SET_USERS_DATA: 'SET_USERS_DATA',
  UPDATE_USER: 'UPDATE_USER',
  DELETE_USER: 'DELETE_USER',
  MUTATION_ADD_USER: 'MUTATION_ADD_USER',
  MUTATION_UPDATE_USER_CAR: 'MUTATION_UPDATE_USER_CAR',
  MUTATION_NEW_USER_CAR: 'MUTATION_NEW_USER_CAR'
}

export default {
  moduleName,

  namespaced: true,

  state: () => ({
    checkedUserManagerTableRows: [],
    users: [],
    usersCount: 0
  }),

  actions: {
    [actionTypes.ACTION_INIT_WS] ({ commit }) {
      const onUpdateUser = ({ value }) => {
        commit(mutationTypes.UPDATE_USER, value.user)
      }

      const onDeleteUser = ({ value }) => {
        commit(mutationTypes.DELETE_USER, value)
      }

      const onAddUser = ({ value }) => {
        commit(mutationTypes.MUTATION_ADD_USER, value.user)
      }

      const onUpdateCar = ({ value }) => {
        commit(mutationTypes.MUTATION_UPDATE_USER_CAR, value.car)
      }

      const onNewUserCar = ({ value }) => {
        commit(mutationTypes.MUTATION_NEW_USER_CAR, value.car)
      }

      API.userManager.wsListeners[API.userManager.wsEvents.USER_MANAGER_NEW_USER_CAR](onNewUserCar)
      API.userManager.wsListeners[API.userManager.wsEvents.USER_MANAGER_DELETE_USER](onDeleteUser)
      API.userManager.wsListeners[API.userManager.wsEvents.USER_MANAGER_UPDATE_USER](onUpdateUser)
      API.userManager.wsListeners[API.userManager.wsEvents.USER_MANAGER_ADD_USER](onAddUser)
      API.userManager.wsListeners[API.userManager.wsEvents.USER_MANAGER_UPDATE_USER_CAR](onUpdateCar)
    },

    [actionTypes.ACTION_JOIN_TO_USER_MANAGER] ({ commit }) {
      API.userManager.wsActions.ACTION_JOIN_TO_USER_MANAGER()
    },

    [actionTypes.ACTION_DELETE_USER] ({ commit }, payload) {
      API.userManager.wsActions.ACTION_DELETE_USER(payload)
    },

    async [actionTypes.ACTION_LOAD_USERS] ({ commit }, payload) {
      const response = await API.userManager.loadUsers(payload)
      const { users, count } = response.data
      commit(mutationTypes.SET_USERS_DATA, [users, count])
    }
  },

  mutations: {
    [mutationTypes.UNSET_CHECKED_ROWS] (state) {
      state.checkedUserManagerTableRows = []
    },

    [mutationTypes.SET_CHECKED_ROW] (state, row) {
      const targetIndex = state.checkedUserManagerTableRows.indexOf(row)
      if (targetIndex >= 0) {
        state.checkedUserManagerTableRows.splice(targetIndex, 1)
      } else {
        state.checkedUserManagerTableRows.push(row)
      }
    },

    [mutationTypes.SET_CHECKED_ROWS] (state, rows) {
      if (state.checkedUserManagerTableRows.length > 0 && state.checkedUserManagerTableRows.every(row => rows.includes(row))) {
        state.checkedUserManagerTableRows = []
      } else {
        state.checkedUserManagerTableRows = [...rows]
      }
    },

    [mutationTypes.SET_USERS_DATA] (state, [users, usersCount]) {
      state.users = users
      state.usersCount = usersCount
    },

    [mutationTypes.UPDATE_USER] (state, user) {
      const userIndex = state.users.findIndex(u => getRawUserId(u) === getRawUserId(user))
      if (userIndex >= 0) {
        state.users.splice(userIndex, 1, {
          ...state.users[userIndex],
          ...createUserObject(user)
        })
      }
    },

    [mutationTypes.DELETE_USER] (state, { deletedUsers, appendedUsers, usersCount }) {
      if (Array.isArray(deletedUsers) && Array.isArray(appendedUsers)) {
        deletedUsers.forEach(deletedUser => {
          const userIndex = state.users.findIndex(u => getRawUserId(u) === getRawUserId(deletedUser))
          if (userIndex >= 0) {
            state.users.splice(userIndex, 1)
          }
        })

        state.users.push(...appendedUsers)
        state.usersCount = usersCount
      }
    },

    [mutationTypes.MUTATION_ADD_USER] (state, user) {
      state.users.pop()
      state.users.unshift(createUserObject(user))
      state.usersCount++
    },

    [mutationTypes.MUTATION_UPDATE_USER_CAR] (state, car) {
      const userIndex = state.users.findIndex(u => getRawUserCarId(u) === car.id)
      if (userIndex >= 0) {
        state.users.splice(userIndex, 1, {
          ...state.users[userIndex],
          ...createUserCarObject(car)
        })
      }
    },

    [mutationTypes.MUTATION_NEW_USER_CAR](state, car) {
      const userIndex = state.users.findIndex(u => getRawUserId(u) === getRawUserId(car))
      if (userIndex >= 0) {
        state.users.splice(userIndex, 1, {
          ...state.users[userIndex],
          ...car
        })
      }
    }
  },

  getters: {
    [getterTypes.GETTER_CHECKED_ROWS]: (state) => state.checkedUserManagerTableRows,
    [getterTypes.GETTER_USERS]: (state) => state.users,
    [getterTypes.GETTER_USERS_COUNT]: (state) => state.usersCount
  }
}
